// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UiDLEPvgOSycRbX680T0{padding:12px}.ProKKW2FEfvDCa75TPlI{border:none;padding:0}.WpLT5p_8lK1y0Ock36f0{margin-bottom:4px}`, "",{"version":3,"sources":["webpack://./src/shared/ui/DatePicker/ui/DatetimePickerTextField/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,YAAA,CAGF,sBACE,WAAA,CACA,SAAA,CAGF,sBACE,iBAAA","sourcesContent":[".wrapDropdown {\n  padding: 12px;\n}\n\n.calendarClassName {\n  border: none;\n  padding: 0;\n}\n\n.wrapInputsClassName {\n  margin-bottom: 4px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapDropdown": `UiDLEPvgOSycRbX680T0`,
	"calendarClassName": `ProKKW2FEfvDCa75TPlI`,
	"wrapInputsClassName": `WpLT5p_8lK1y0Ock36f0`
};
export default ___CSS_LOADER_EXPORT___;
